"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AltiumSheetEntryNamingRule = void 0;
const sigma_engine_shared_1 = require("@cadstrom/sigma-engine-shared");
const AltiumNetNamingRule_1 = require("./AltiumNetNamingRule");
const AltiumEnums_1 = require("../../common/AltiumEnums");
const AltiumSheetEntryNamingEligibility_1 = require("./AltiumSheetEntryNamingEligibility");
class AltiumSheetEntryNamingRule extends AltiumNetNamingRule_1.AltiumNetNamingRule {
    apply(group, _hierarchy) {
        if (!this.config.allowSheetEntryNetNames) {
            return undefined;
        }
        if (!group.hasLabelType('sheet-entry')) {
            return undefined;
        }
        if (!group.hasLabelType('port')) {
            return undefined;
        }
        const sheetEntryNames = [];
        for (const label of group.getNetLabels()) {
            if (label.labelType === 'sheet-entry' && this.canUseSheetEntryName(group, label)) {
                sheetEntryNames.push(label.formattedLabel ?? label.originalLabel);
            }
        }
        if (sheetEntryNames.length === 0) {
            return undefined;
        }
        sheetEntryNames.sort((a, b) => sigma_engine_shared_1.Utils.naturalStringSort(a, b));
        return this.dereferenceLabelName(sheetEntryNames[0]);
    }
    canUseSheetEntryName(group, label) {
        const metadata = label.strategyMetadata?.['sheet-entry-metadata'];
        if (!metadata) {
            return (0, AltiumSheetEntryNamingEligibility_1.isAltiumSheetEntryNamingEligible)(group, label, this.config.mode, false);
        }
        return ((0, AltiumSheetEntryNamingEligibility_1.isAltiumSheetEntryNamingEligible)(group, label, this.config.mode, false) &&
            !metadata.isRepeated &&
            metadata.channelIndexes.length <= 1 &&
            metadata.ioType !== AltiumEnums_1.PortIOType.Input);
    }
}
exports.AltiumSheetEntryNamingRule = AltiumSheetEntryNamingRule;
//# sourceMappingURL=AltiumSheetEntryNamingRule.js.map